import { Toaster } from "sonner";

/** Neutral, no-emoji toast host. Bottom-right, 6s auto-dismiss (spec §7.4). */
export function ToastHost() {
  return (
    <Toaster
      position="bottom-right"
      duration={6000}
      toastOptions={{
        classNames: {
          toast:
            "rounded-md border border-line bg-card text-ink shadow-overlay text-sm",
          description: "text-mute",
        },
      }}
    />
  );
}
